import { Stack, Typography } from '@montugroup/design-system';
import { TextContainer } from './States.styles';

// mvp content is the same as InvalidTokenPendingInvite
export const DuplicateTokenPendingInvite = () => {
  return (
    <TextContainer data-testid="pharmacist-escript-duplicate-token-pending-invite">
      <Stack spacing={6}>
        <Typography variant="subtitle1" fontWeight={600}>
          Token already in progress
        </Typography>
        <Typography>
          This token has already been entered but your customer has not accepted their uMeds invite yet.
        </Typography>
        <Typography>
          We have sent them another email and/or SMS to complete their sign up. Once they accept the invite we`ll take
          care of the rest
        </Typography>
      </Stack>
    </TextContainer>
  );
};
